import React from 'react';
import MemoryForm from './MemoryForm';
import CreateMemoryModal from 'components/Memories/Modals/CreateMemoryModal';
import { useDialog } from 'hooks/common/useDialog';
import { useMemoryByID } from 'hooks/memory/useMemoryByID';

export type MemoryFormType = {
  stepTitle: string;
  memoryID: string;
  query: string;
  minimumRelevance: number;
  limit: number;
  description: string;
};

type MemoryFormContainerProps = {
  memoryID: string | null;
  promptFunctionID: string;
  handleContinue: () => void;
};

function MemoryFormContainer({
  memoryID,
  promptFunctionID,
  handleContinue,
}: MemoryFormContainerProps) {
  const { joinedMemory } = useMemoryByID(memoryID);

  const {
    open: isCreateMemoryDialogOpen,
    closeDialog: closeCreateMemoryDialog,
    openDialog: openCreateMemoryDialog,
  } = useDialog();

  const handleTestClick = () => {
    handleContinue();
  };

  return (
    <>
      {!!joinedMemory && (
        <MemoryForm
          selectedMemory={joinedMemory}
          handleTestClick={handleTestClick}
          promptFunctionID={promptFunctionID}
          openCreateMemoryDialog={openCreateMemoryDialog}
        />
      )}
      {isCreateMemoryDialogOpen && (
        <CreateMemoryModal
          open={isCreateMemoryDialogOpen}
          onClose={closeCreateMemoryDialog}
        />
      )}
    </>
  );
}

export default MemoryFormContainer;
